<template>
  <div class="min-h-screen theme-bg">
    <!-- 顶部导航栏 -->
    <header class="bg-white shadow-sm fixed top-0 left-0 right-0 z-50">
      <div class="px-4 py-3 theme-header">
        <h1 class="text-lg font-semibold text-center text-gray-800 paw-pattern">宠物监测</h1>
      </div>
    </header>

    <!-- 主要内容区域 -->
    <main class="pt-16 pb-20 px-4">
      <!-- 宠物状态概览 -->
      <div class="bg-white rounded-2xl p-6 shadow-lg mb-6 theme-gradient-bg">
        <div class="flex items-center mb-6">
          <div class="relative">
            <img 
              :src="petInfo.petImage ? petInfo.petImage : 'https://airpets-image.oss-cn-chengdu.aliyuncs.com/userImage/petDefaultImage.png'" 
              alt="宠物照片" 
              class="w-20 h-20 rounded-full object-cover cursor-pointer pet-photo floating"
              @click="openPhotoModal"
            >
            <span 
              class="absolute bottom-0 right-0 w-6 h-6 bg-white bg-opacity-90 rounded-full border-2 border-green-100 flex items-center justify-center cursor-pointer hover:bg-green-50"
              @click="openPhotoModal"
            >
              <img class="pawIcon" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/paw.png"/>
              <!-- <font-awesome-icon icon="paw" :style="{color: machineStatus}" class="text-green-500 text-xs" /> -->
            </span>
          </div>
          <div class="ml-4 cursor-pointer" @click="openPetInfoModal">
            <h2 class="text-xl font-bold text-gray-800 mb-1">{{petInfo.petName}}</h2>
            <p class="text-sm text-gray-500 bg-blue-50 px-3 py-1 rounded-full inline-flex items-center">
              <img class="dogIcon" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/dog.png"/>
              <!-- <font-awesome-icon icon="dog" class="mr-2 theme-icon" /> -->
              {{petInfo.variety}} • {{petInfo.age}}岁 • {{petInfo.weightKg}}kg
            </p>
          </div>
        </div>
        <!-- 3D模型展示区 -->
        <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 mb-6">
          <div class="aspect-video flex items-center justify-center bg-white bg-opacity-50 rounded-lg">
            <div class="text-center floating">
              <Dog ref="dogRef" @onDogReady="onDogReady"></Dog>
            </div>
          </div>
          <!-- <div v-if="lookStatus" class="playback"> -->
          <div v-if="lookStatus">
            <!-- <Time width="250"/> -->
             <TimeLine ref="mentPageRef" :listTime="list" @setTime="getTimes" @dragTime="setDragTime" @stateChange="stateChange"/>
            <!-- <SegmentPage ref="mentPageRef" :segments="segments" @setTime="getTimes" @dragTime="setDragTime"/> -->
          </div>
          <div class="flex justify-end mt-3">
            <button @click="lookFun" style="display: flex;align-items: center;" class="px-4 py-2 bg-white theme-text-primary rounded-full text-sm shadow-sm hover:shadow-md transition-all">
              <!-- <font-awesome-icon icon="play" class="mr-1" /> -->
              <img class="playIcon" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/play.png"/>
              查看回放
            </button>
          </div>
        </div>

        <!-- 健康状态卡片 -->
        <div class="grid grid-cols-3 gap-3 mb-6">
          <!-- 消耗卡片 -->
          <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-3">
            <div class="flex items-center gridCard">
              <div style="display: flex;align-items: center;">
                <div class="w-9 h-9 rounded-full bg-white bg-opacity-70 flex items-center justify-center mr-3">
                  <!-- <font-awesome-icon icon="fire" class="text-lg theme-icon" /> -->
                  <img class="fireIcon" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/fire.png"/>
                </div>
                <p class="text-lg font-bold stat-value mb-0.5">{{petMotion.totalCalorie}}</p>
              </div>
              <div>
                <p class="text-xs text-gray-600">消耗·千卡</p>
              </div>
            </div>
          </div>

          <!-- 进食卡片 -->
          <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-3">
            <div class="flex items-center gridCard">
              <div style="display: flex;align-items: center;">
                <div class="w-9 h-9 rounded-full bg-white bg-opacity-70 flex items-center justify-center mr-3">
                  <!-- <font-awesome-icon icon="utensils" class="text-lg theme-icon" /> -->
                  <img class="utensilsIcon" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/utensils.png"/>
                </div>
                <p class="text-lg font-bold stat-value mb-0.5">{{ eatNum }}</p>
              </div>
              <div>
                <p class="text-xs text-gray-600">进食·次数</p>
              </div>
            </div>
          </div>

          <!-- 步数卡片 -->
          <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-3">
            <div class="flex items-center gridCard">
              <div style="display: flex;align-items: center;">
                <div class="w-9 h-9 rounded-full bg-white bg-opacity-70 flex items-center justify-center mr-3">
                  <!-- <font-awesome-icon icon="shoe-prints" class="text-lg theme-icon" /> -->
                  <img src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/shoe-prints.png"/>
                </div>
                <p class="text-lg font-bold stat-value mb-0.5">{{petMotion.walkingDistance}}</p>
              </div>
              <div>
                <p class="text-xs text-gray-600">步数·总量</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 今日活动记录 -->
        <div class="space-y-4">
          <h3 class="text-lg font-bold text-gray-800 mb-4 paw-pattern">今日活动</h3>
          <div class="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4">
            <div class="space-y-3">
              <!-- 走路时间 -->
              <div class="flex items-center justify-between p-3 bg-white bg-opacity-50 rounded-lg hover:bg-opacity-70 transition-all">
                <div class="flex items-center">
                  <div class="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                    <!-- <font-awesome-icon icon="walking" class="text-xl theme-icon" /> -->
                    <img class="walkIcon" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/walking.png"/>
                  </div>
                  <span class="text-gray-700 ml-3 font-medium">走路时间</span>
                </div>
                <div>
                  <div class="font-medium stat-value">{{petMotion.walkingTime}}</div>
                  <div class="text-sm text-gray-500">{{petMotion.walkingDistance}}</div>
                </div>
                
              </div>

              <!-- 跑步时间 -->
              <div class="flex items-center justify-between p-3 bg-white bg-opacity-50 rounded-lg hover:bg-opacity-70 transition-all">
                <div class="flex items-center">
                  <div class="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                    <!-- <font-awesome-icon icon="running" class="text-xl theme-icon" /> -->
                    <img class="walkIcon" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/running.png"/>
                  </div>
                  <span class="text-gray-700 ml-3 font-medium">跑步时间</span>
                </div>
                <div>
                  <div class="font-medium stat-value">{{petMotion.runningTime}}</div>
                  <div class="text-sm text-gray-500">{{petMotion.runningDistance}}</div>
                </div>
              </div>

              <!-- 休息时间 -->
              <div class="flex items-center justify-between p-3 bg-white bg-opacity-50 rounded-lg hover:bg-opacity-70 transition-all">
                <div class="flex items-center">
                  <div class="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                    <!-- <font-awesome-icon icon="moon" class="text-xl theme-icon" /> -->
                    <img class="walkIcon" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/sleep.png"/>
                  </div>
                  <span class="text-gray-700 ml-3 font-medium">休息时间</span>
                </div>
                <div>
                  <div class="font-medium stat-value">{{petMotion.restingTime}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- 底部导航栏 -->
    <nav class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-lg">
      <div class="grid grid-cols-5 py-2 theme-header">
        <router-link to="/home" exact active-class="nav-active" class="routerLink">
          <!-- <font-awesome-icon icon="home" class="text-xl" /> -->
          <img style="width: 22px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/selHome.png"/>
          <!-- <img style="width: 22px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/home.png"/> -->
          <p class="text-xs mt-1">首页</p>
        </router-link>
        <router-link to="/location" exact active-class="nav-active" class="routerLink">
          <!-- <font-awesome-icon icon="map-marker-alt" class="text-xl" /> -->
          <!-- <img style="width: 22px;height: 22px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/SelPosition.png"/> -->
          <img style="width: 22px;height: 22px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/position.png"/>
          <p class="text-xs mt-1">定位</p>
        </router-link>
        <router-link to="/ai-diagnosis" exact active-class="nav-active" class="routerLink">
          <!-- <font-awesome-icon icon="robot" class="text-xl" /> -->
          <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/robotAi.png"/>
          <!-- <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/selRobotAi.png"/> -->
          <p class="text-xs mt-1">AI问诊</p>
        </router-link>
        <router-link to="/device-list" exact active-class="nav-active" class="routerLink">
          <!-- <font-awesome-icon icon="microchip" class="text-xl" /> -->
          <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/microchip.png"/>
          <!-- <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/selMicrochip.png"/> -->
          <p class="text-xs mt-1">设备</p>
        </router-link>
        <router-link to="/profile" exact active-class="nav-active" class="routerLink">
          <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/user.png"/>
          <!-- <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/selUser.png"/> -->
          <!-- <font-awesome-icon icon="user" class="text-xl" /> -->
          <p class="text-xs mt-1">我的</p>
        </router-link>
      </div>
    </nav>

    <!-- 照片编辑模态框 -->
    <div id="photoModal" class="modal" :class="{'show': showPhotoModal}">
      <div class="bg-white w-10/12 max-w-sm mx-auto mt-24 rounded-2xl p-3 shadow-lg" style="height: 35%;">
        <div class="flex justify-between items-center mb-2">
          <h3 class="text-base font-semibold text-gray-800">更换照片</h3>
          <button @click="showPhotoModal = false" class="text-gray-500 hover:text-gray-700">
            <!-- <font-awesome-icon icon="times" /> -->
          </button>
        </div>
        <div class="space-y-2">
          <div class="border-2 border-dashed border-gray-300 rounded-lg p-3 text-center hover:border-blue-400 transition-colors" style="position: relative;">
            <input type="file" id="petPhoto" accept="image/*" class="hidden uploadInput" ref="fileInput" @change="afterRead">
            <img v-if="temporaryImg" :src="temporaryImg" style="width: 100%;height: 150px;"/>
            <label v-else for="petPhoto" class="cursor-pointer block">
              <!-- <font-awesome-icon icon="camera" class="text-gray-400 text-2xl mb-1" /> -->
              <p class="text-sm text-gray-500">点击上传照片</p>
              <p class="text-xs text-gray-400">支持 JPG、PNG 格式，大小不超过 5MB</p>
            </label>
          </div>
          <button 
            @click="savePhoto" 
            class="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 transition-colors font-medium"
          >
            保存
          </button>
        </div>
      </div>
    </div>

    <!-- 宠物信息编辑模态框 -->
    <div id="petInfoModal" class="modal" :class="{'show': showPetInfoModal}">
      <div class="bg-white w-10/12 max-w-sm mx-auto mt-24 rounded-2xl p-3 shadow-lg">
        <div class="flex justify-between items-center mb-2">
          <h3 class="text-base font-semibold text-gray-800">编辑宠物信息</h3>
          <button @click="showPetInfoModal = false" class="text-gray-500 hover:text-gray-700">
            <!-- <font-awesome-icon icon="times" /> -->
            <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/times.png"/>
          </button>
        </div>
        <div class="space-y-2">
          <!-- 名称输入框 -->
          <div class="relative">
            <input 
              type="text" 
              v-model="petInfo.petName" 
              class="w-full border rounded-lg px-3 py-2 pt-4 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition-all" 
              placeholder=" "
            >
            <label class="absolute text-xs text-gray-500 top-1 left-3">名称</label>
          </div>
          <!-- 类型选择框 -->
          <div class="relative">
            <select 
              v-model="petInfo.varietyType" 
              class="w-full border rounded-lg px-3 py-2 pt-4 appearance-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition-all"
            >
              <option value="">请选择类型</option>
              <option value="1">狗</option>
              <option value="2">猫</option>
            </select>
            <label class="absolute text-xs text-gray-500 top-1 left-3">宠物类型</label>
            <img style="width: 25px;height: 25px;" class="absolute right-3 top-3 text-gray-400 pointer-events-none" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/chevron-down.png"/>
            <!-- <font-awesome-icon icon="chevron-down" class="absolute right-3 top-3 text-gray-400 pointer-events-none" /> -->
          </div>
          <!-- 品种选择框 -->
          <div class="relative">
            <select 
              v-model="petInfo.varietyId" 
              class="w-full border rounded-lg px-3 py-2 pt-4 appearance-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition-all"
            >
              <option value="">请选择</option>
              <option v-for="item in petList" :key="item.varietyId" :value="item.varietyId">{{ item.variety }}</option>
            </select>
            <label class="absolute text-xs text-gray-500 top-1 left-3">品种</label>
            <img style="width: 25px;height: 25px;" class="absolute right-3 top-3 text-gray-400 pointer-events-none" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/chevron-down.png"/>
            <!-- <font-awesome-icon icon="chevron-down" class="absolute right-3 top-3 text-gray-400 pointer-events-none" /> -->
          </div>
          
          <div class="grid grid-cols-2 gap-2">
            <!-- 年龄输入框 -->
            <div class="relative">
              <input 
                type="number" 
                v-model.number="petInfo.age" 
                class="w-full border rounded-lg px-3 py-2 pt-4 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition-all" 
                min="1" 
                max="99"
                @input="validateAge"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              >
              <label class="absolute text-xs text-gray-500 top-1 left-3">年龄</label>
              <span class="absolute right-3 top-3 text-gray-500 text-xs">岁</span>
            </div>
            
            <!-- 体重输入框 -->
            <div class="relative">
              <input 
                type="text" 
                v-model="petInfo.weightKg" 
                class="w-full border rounded-lg px-3 py-2 pt-4 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition-all" 
                @input="validateWeight"
                @blur="formatWeight"
              >
              <label class="absolute text-xs text-gray-500 top-1 left-3">体重</label>
              <span class="absolute right-3 top-3 text-gray-500 text-xs">kg</span>
            </div>
          </div>
          
          <button 
            @click="savePetInfo" 
            class="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 transition-colors font-medium"
          >
            保存
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { RPC } from '@/api/rpc'
import Dog from '@/components/dog.vue'
import SegmentPage from '@/components/Segment.vue';
import dayjs from 'dayjs'
import TimeLine from '@/components/timeLine.vue'
export default {
  name: 'Home',
  components: {
    Dog,SegmentPage,TimeLine
  },
  data() {
    return {
      lookStatus: false,
      segments: true,
      s: 0,
      list: [],
      runStatu: 0,
      lyingStatu: 0,
      walkingStatu: 0,
      standingStatu: 0,
      sittingStatu: 0,
      eattingStatu: 0,
      timerId: null,
      timer: null,
      startTime: '',
      endTime: '',
      statistics: [
        { label: '活动时长', value: '2.5h' },
        { label: '运动步数', value: '5.8k' },
        { label: '消耗热量', value: '520' }
      ],
      petInfo: {
      },
      showPhotoModal: false,
      showPetInfoModal: false,
      showBreedPicker: false,
      fileList: [],
      machineId: null,
      machineStatus: 'green',
      temporaryImg: '',
      petList: [],
      petMotion: {},
      eatNum: null,
    }
  },
  beforeDestroy() {
    clearInterval(this.timerId)
    clearInterval(this.timer)
  },
  computed: {
    ...mapGetters(['currentDevice'])
  },
  methods: {
    ...mapActions(['updateDevices']),
    lookFun() {
      this.lookStatus = !this.lookStatus
      if (this.lookStatus) {
        clearInterval(this.timerId)
        this.timerId = null
        this.endTime = new Date().getTime();
        this.startTime = new Date().getTime() - 2 * 60 * 60 * 1000
        this.getPestList()
      } else {
        clearInterval(this.timer)
        this.timer = null
        this.getPetInfo()
      }
    },
    getPet(machineId) {
      // running 跑,sitting 坐,standing 站立,walking 行走,lying 爬,eatting 吃
      RPC.getPetStatus({machineId}).then(res=>{
        if (res.data.attitude == "running" && this.runStatu == 0) {
          this.runStatu = 1
          this.lyingStatu = 0
          this.walkingStatu = 0
          this.standingStatu = 0
          this.sittingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onRun()
        }
        if (res.data.attitude == "sitting" && this.sittingStatu == 0) {
          this.sittingStatu = 1
          this.runStatu = 0
          this.lyingStatu = 0
          this.walkingStatu = 0
          this.standingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onSitting()
        }
        if (res.data.attitude == "standing" && this.standingStatu == 0) {
          this.standingStatu = 1
          this.runStatu = 0
          this.lyingStatu = 0
          this.walkingStatu = 0
          this.sittingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onStanding()
        }
        if (res.data.attitude == "walking" && this.walkingStatu == 0) {
          this.walkingStatu = 1
          this.runStatu = 0
          this.lyingStatu = 0
          this.standingStatu = 0
          this.sittingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onWalking()
        }
        if (res.data.attitude == "lying" && this.lyingStatu == 0) {
          this.lyingStatu = 1
          this.runStatu = 0
          this.walkingStatu = 0
          this.standingStatu = 0
          this.sittingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onLying()
        }
        if (res.data.attitude == "eatting" && this.eattingStatu == 0) {
          this.eattingStatu = 1
          this.runStatu = 0
          this.lyingStatu = 0
          this.walkingStatu = 0
          this.standingStatu = 0
          this.sittingStatu = 0
          this.$refs.dogRef.onEat()
        }
      })
    },
    setDragTime(row) {
      // let currentTime = time.currentTime
      // this.s = this.list.findIndex((item)=>{
      //   return item.receivedTime == currentTime
      // })
      this.s = row.currentIndex
      if (this.s == this.list.length || this.s == -1) {
          clearInterval(this.timer)
          this.timer = null
          return
        }
        // 使用映射表替代多层if-else
        this.time = this.list[this.s].receivedTime
        // let selList = this.list[this.s]
        let selList = row.pointerValue.status
        if (selList == "running" && this.runStatu == 0) {
          this.runStatu = 1
          this.lyingStatu = 0
          this.walkingStatu = 0
          this.standingStatu = 0
          this.sittingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onRun()
        }
        if (selList == "sitting" && this.sittingStatu == 0) {
          this.sittingStatu = 1
          this.runStatu = 0
          this.lyingStatu = 0
          this.walkingStatu = 0
          this.standingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onSitting()
        }
        if (selList == "standing" && this.standingStatu == 0) {
          this.standingStatu = 1
          this.runStatu = 0
          this.lyingStatu = 0
          this.walkingStatu = 0
          this.sittingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onStanding()
        }
        if (selList == "walking" && this.walkingStatu == 0) {
          this.walkingStatu = 1
          this.runStatu = 0
          this.lyingStatu = 0
          this.standingStatu = 0
          this.sittingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onWalking()
        }
        if (selList == "lying" && this.lyingStatu == 0) {
          this.lyingStatu = 1
          this.runStatu = 0
          this.walkingStatu = 0
          this.standingStatu = 0
          this.sittingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onLying()
        }
        if (selList == "eatting" && this.eattingStatu == 0) {
          this.eattingStatu = 1
          this.runStatu = 0
          this.lyingStatu = 0
          this.walkingStatu = 0
          this.standingStatu = 0
          this.sittingStatu = 0
          this.$refs.dogRef.onEat()
        }
      // clearInterval(this.timer)  
      // this.setTimeStatu()
    },
    stateChange(e) {
      console.log('2345',e)
      if (e.isPausedByDrag) {

      }
    },
    getTimes(item) {
      this.s = 0
      this.endTime = item.endTime
      this.startTime = item.startTime
      clearInterval(this.timer)  
      this.getPestList()
    },
    getPestList() {
      let data = {
        "endTime": dayjs(this.endTime).format('YYYY-MM-DD HH:mm:ss'),
        "machineId": this.machineId,
        "pageIndex": 1,
        "pageSize": 7200,
        "startTime": dayjs(this.startTime).format('YYYY-MM-DD HH:mm:ss'),
      }
      RPC.petsList(data).then(res=>{
        if (res.list.length == 0) {
          this.segments = false
        } else {
          this.segments = true
        }
        this.list = res.list
        res.list.map(item=>{
          item.times = new Date(item.receivedTime).getTime()
        })
        this.list = this.fixMissingTimestamps(res.list)
        this.$refs.mentPageRef.getList(this.list)
        this.setTimeStatu()
      })
    },
    fixMissingTimestamps(data) {
      // 1. 提取并转换时间戳（秒级）
      const seconds = data.map(item => Math.floor(item.times / 1000)).sort((a, b) => a - b);
      // 2. 补全缺失时间
      const complete = [];
      for (let i = 0; i < seconds.length; i++) {
        complete.push(seconds[i]);
        if (i === seconds.length - 1) break;
        const current = seconds[i];
        const next = seconds[i + 1];
        const gap = next - current;
        if (gap > 1) {
          for (let j = current + 1; j < next; j++) {
            complete.push(j);
          }
        }
      }
      // 3. 生成完整结果（转换回毫秒级）
      return complete.map(sec => ({
        times: sec * 1000,
        attitude:data.find(item => Math.floor(item.times / 1000) === sec)?.attitude ?? 'standing',
        receivedTime: new Date(sec * 1000).toLocaleString('zh-CN', { 
          hour12: false, 
          year: 'numeric', 
          month: '2-digit', 
          day: '2-digit', 
          hour: '2-digit', 
          minute: '2-digit', 
          second: '2-digit' 
        }).replace(/\//g, '-')
      }));
    },
    setTimeStatu() {
      if (this.list.length==0) {
        clearInterval(this.timer)
        this.timer = null
        return
      }
      // this.timer = setInterval(() => {
      //   if (this.s == this.list.length || this.s == -1) {
      //     clearInterval(this.timer)
      //     this.timer = null
      //     return
      //   }
      //   // 使用映射表替代多层if-else
      //   this.time = this.list[this.s].receivedTime
        let selList = this.list[this.s]
        console.log('selList',selList)
        if (selList.attitude == "running" && this.runStatu == 0) {
          this.runStatu = 1
          this.lyingStatu = 0
          this.walkingStatu = 0
          this.standingStatu = 0
          this.sittingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onRun()
        }
        if (selList.attitude == "sitting" && this.sittingStatu == 0) {
          this.sittingStatu = 1
          this.runStatu = 0
          this.lyingStatu = 0
          this.walkingStatu = 0
          this.standingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onSitting()
        }
        if (selList.attitude == "standing" && this.standingStatu == 0) {
          this.standingStatu = 1
          this.runStatu = 0
          this.lyingStatu = 0
          this.walkingStatu = 0
          this.sittingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onStanding()
        }
        if (selList.attitude == "walking" && this.walkingStatu == 0) {
          this.walkingStatu = 1
          this.runStatu = 0
          this.lyingStatu = 0
          this.standingStatu = 0
          this.sittingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onWalking()
        }
        if (selList.attitude == "lying" && this.lyingStatu == 0) {
          this.lyingStatu = 1
          this.runStatu = 0
          this.walkingStatu = 0
          this.standingStatu = 0
          this.sittingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onLying()
        }
        if (selList.attitude == "eatting" && this.eattingStatu == 0) {
          this.eattingStatu = 1
          this.runStatu = 0
          this.lyingStatu = 0
          this.walkingStatu = 0
          this.standingStatu = 0
          this.sittingStatu = 0
          this.$refs.dogRef.onEat()
        }
        
        // this.s = this.s + 1
      // }, 1000)
    },
    openPhotoModal() {
      this.showPhotoModal = true
    },
    openPetInfoModal() {
      this.showPetInfoModal = true
    },
    afterRead(event) {
      const client = new FormData();
			client.append('file', event.target.files[0])
      RPC.uploadPetImageFile(client).then(res=>{
        this.temporaryImg = res
      })
    },
    savePhoto() {
      if (this.temporaryImg) {
        let data = {
          machineId: this.machineId,
          petImage: this.temporaryImg
        }
        RPC.updatePetImage(data).then(res=>{
          this.$toast.success('照片保存成功')
          this.showPhotoModal = false
          this.getPetInfo()
        })
      }
    },
    onBreedConfirm(value) {
      this.petInfo.variety = value
      this.showBreedPicker = false
    },
    savePetInfo() { 
      let data = {
        machineId: this.machineId,
        petName: this.petInfo.petName,
        varietyId: this.petInfo.varietyId,
        varietyType: this.petInfo.varietyType,
      }
      this.petList.map(item=>{
        if (item.varietyId == this.petInfo.varietyId) {
          this.petInfo.variety = item.variety
        }
      })
      RPC.updateVariety(this.petInfo).then(res=>{
        this.showPetInfoModal = false
        this.$toast.success('宠物信息保存成功')
      })
    },
    formatWeight() {
      if (this.petInfo.weightKg) {
        let weight = parseFloat(parseFloat(this.petInfo.weightKg).toFixed(1));
        this.petInfo.weightKg = Math.min(200, weight);
      }
    },
    validateAge() {
      if (this.petInfo.age) {
        this.petInfo.age = Math.min(99, Math.max(1, Math.floor(this.petInfo.age)))
      }
    },
    validateWeight() {
      const value = this.petInfo.weightKg;
      const regex = /^[0-9]*\.?[0-9]?$/;
      if (!regex.test(value)) {
        const parts = value.split('.');
        if (parts.length > 1) {
          this.petInfo.weightKg = parts[0] + '.' + parts[1].substring(0, 1);
        } else {
          this.petInfo.weightKg = value.replace(/[^0-9]/g, '');
        }
      }
      
      if (parseFloat(value) > 200) {
        this.petInfo.weightKg = '200';
      }
    },
    setMachineRate(){
      let data = {
        "machineId": this.machineId,
        "rate": 1
      }
      RPC.updateSpeed(data).then(res=>{
        console.log('11',res)
      })
    },
    getPetInfo() {
      clearInterval(this.timerId);
      RPC.machineInfo({machineId: this.machineId}).then(res=>{
        if (res.data.machineStatus == 'offline') {
          this.machineStatus = 'gray'
          clearInterval(this.timerId);
          this.timerId = null;
          this.runStatu = 0
          this.lyingStatu = 0
          this.walkingStatu = 0
          this.standingStatu = 0
          this.sittingStatu = 0
          this.eattingStatu = 0
          this.$refs.dogRef.onStanding()
        } else {
          this.machineStatus = 'green'
          this.timerId = setInterval(() => {
            this.getPet(this.machineId)
          }, 1000)
          this.setMachineRate()
        }
        this.petInfo = res.data
        this.getPetList()
      })
    },
    getPetList() {
      RPC.getPetList({
        "pageIndex": 1,
        "pageSize": 100,
        "variety": "",
        "varietyType": this.petInfo.varietyType
      }).then(res=>{
        this.petList = res.list
      })
    },
    getPetMotion() {
      let currentTime = dayjs(this.endTime).format('YYYY-MM-DD')
      let data = {
        "endTime": currentTime + ' 23:59:59',
        "machineId": this.machineId,
        "startTime": currentTime + ' 00:00:00'
      }
      RPC.motionInformation(data).then(res=>{
        this.petMotion = res.data
      })
      RPC.eatCount(data).then(res=>{
        this.eatNum = res.data.eatCount
      })
    },
    onDogReady(e) {
      this.getPetInfo()
    }
  },
  mounted() {
    this.machineId = sessionStorage.getItem('deviceCode')?sessionStorage.getItem('deviceCode') : null
    this.endTime = new Date().getTime();
    this.startTime = new Date().getTime() - 2 * 60 * 60 * 1000
    this.getPetMotion()
    window.addEventListener('click', (event) => {
      if (event.target.classList.contains('modal')) {
        this.showPhotoModal = false;
        this.showPetInfoModal = false;
      }
    });
  }
}
</script>

<style scoped>
body {
  background-color: var(--background-color);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.stat-card {
  transition: all 0.3s ease;
  border-radius: 16px;
}

.stat-card:active {
  transform: scale(0.98);
}

.pet-photo {
  border: 3px solid var(--primary-color);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-value {
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.paw-pattern {
  position: relative;
}

.paw-pattern::before {
  content: '🐾';
  position: absolute;
  top: -10px;
  right: -5px;
  font-size: 20px;
  opacity: 0.3;
  transform: rotate(30deg);
}

.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal.show {
  display: flex;
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
  100% { transform: translateY(0px); }
}

.floating {
  animation: float 3s ease-in-out infinite;
}

/* 输入框样式增强 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

input:focus + label, 
select:focus + label,
input:not(:placeholder-shown) + label,
select:not(:placeholder-shown) + label {
  transform: translateY(-60%) scale(0.85);
  color: var(--primary-color);
}

input + label, 
select + label {
  transition: all 0.2s ease-out;
  transform-origin: left top;
  margin-top: 3px;
}

.nav-active {
  color: var(--accent-color);
}

.nav-active p {
  color: var(--primary-dark);
}

.nav-active .svg-inline--fa {
  color: var(--primary-color);
}
.playback {
  background: linear-gradient(135deg, #FEE0E0 0%, #FECACA 100%);
  border-radius: 0.75rem;
  width: 100%;
  padding: 0.5rem;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.1);
  transition: all 0.3s ease;
}

.playback:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.15);
}
.uploadInput {
  display: block;
  height: 100%;
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  border: 1px solid red;
}
.gridCard {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100%;
}
.pawIcon {
  width: 12px;
  height: 12px;
}
.dogIcon {
  width: 16px;
  height: 14px;
  margin-right: 8px;
}
.playIcon {
  width: 20px;
  height: 20px;
}
.fireIcon {
  width: 18px;
  height: 18px;
}
.utensilsIcon {
  width: 19px;
  height: 18px;
}
.walkIcon {
  width: 20px;
  height: 20px;
}
.routerLink {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
</style> 